<template>
  <div>
    <el-row type="flex" :gutter="6">

      <!--   Chọn khối   -->
      <el-col :span="3">
        <el-select
            v-model="dataFilters.idGrade"
            placeholder="Chọn khối"
            :clearable="true"
            @change="handleChangeGrade"
        >
          <el-option
              v-for="(item, index) in initialDataFilter.listGrades"
              :key="index"
              :label="item.gradeName"
              :value="item.id"
          />
        </el-select>
      </el-col>

      <!--   Chọn lớp   -->
      <el-col :span="3">
        <el-select
            v-model="dataFilters.idClass"
            placeholder="Chọn lớp"
            :clearable="true"
            @change="handleChangeClass"
        >
          <el-option
              v-for="(item, index) in initialDataFilter.listClasses"
              :key="index"
              :label="item.className"
              :value="item.id"/>
        </el-select>
      </el-col>

      <el-col :span="5" style="display: flex">
        <el-input
            :clearable="true"
            placeholder="Nhập tên, SĐT"
            v-model="dataFilters.nameOrPhone"
            @keyup.enter.native="handleSearchResultByName"
            @clear="handleSearchResultByName"
        >
          <template #append>
            <el-button
                icon="el-icon-search"
                @click="handleSearchResultByName"
            ></el-button>
          </template>
        </el-input>
      </el-col>
    </el-row>

    <div style="margin-top: 30px; margin-bottom: 18px">
      <slot/>
    </div>

    <div style="display: flex; justify-content: flex-end; gap: 0 500px;">
      <div>
        <el-pagination
            v-if="parentList.length > 0"
            background
            layout="prev, pager, next, sizes"
            @size-change="handleSizeChange"
            @current-change="handleCurrentPageChange"
            :page-sizes="listSizePage"
            :page-size="pagination.limit"
            :total="totalPage * pagination.limit">
        </el-pagination>
      </div>

      <div>
        <el-menu
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#67c23a"
            text-color="#fff"
            active-text-color="none">
          <el-submenu index="1">
            <template #title>
              <span>Tác vụ</span>
            </template>
            <el-menu-item index="1-1" @click="handleExportExcel">Xuất file Excel</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>

import GradeService from "@/services/GradeService";
import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";
import {mapState} from "vuex";

export default {
  components: {},
  computed: {
    ...mapState("parentStore", [
      "parentList",
      "totalPage",
    ])
  },
  data() {
    return {
      dataFilters: {
        status: "",
        idGrade: "",
        idClass: "",
        nameOrPhone: ""
      },

      initialDataFilter: {
        listGrades: [],
        listClasses: [],
      },

      pagination: {
        page: 1,
        limit: 30,
      },
      listSizePage: [30, 50, 100, 200, 500],
    }
  },

  created() {
    this.fetchInitialDataFilterParent();
    this.fetchDataGrades();
  },

  methods: {
    handleChangeStatusStudent() {
      this.fetchFilterParent();
    },

    handleChangeGrade(value) {
      this.dataFilters.idClass = "";
      this.fetchDataClassesByGrade(value);
      this.fetchFilterParent();
    },

    handleChangeClass() {
      this.fetchFilterParent();
    },

    handleSearchResultByName() {
      this.fetchFilterParent();
    },

    handleSizeChange(value) {
      this.pagination.limit = value;
      this.fetchFilterParent();
    },

    handleCurrentPageChange(value) {
      this.pagination.page = value;
      this.fetchFilterParent();
    },

    /**
     * lấy dữ liệu danh sách khối
     * */
    fetchDataGrades() {
      GradeService.getGradeInPrinciple()
          .then((res) => {
            this.initialDataFilter.listGrades = res.data.data;
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "Lỗi dữ liệu!",
              type: "error",
              duration: 5000
            });
          })
    },

    /**
     * Lấy dữ liệu danh sách lớp
     *
     * @param {number} idGrade - id của khối
     * */
    fetchDataClassesByGrade(idGrade) {
      financeKidsV2Service.getClassInGrade(idGrade)
          .then((res) => {
            this.initialDataFilter.listClasses = res.data.data;
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "Lỗi dữ liệu!",
              type: "error",
              duration: 5000
            });
          });
    },

    fetchFilterParent() {
      const payload = {
        idClass: this.dataFilters.idClass,
        idGrade: this.dataFilters.idGrade,
        status: this.dataFilters.status,
        nameOrPhone: this.dataFilters.nameOrPhone,
        page: this.pagination.page,
        limit: this.pagination.limit,
      }
      this.$store.dispatch('parentStore/fetchFilterManagerParent', payload)
    },

    fetchInitialDataFilterParent() {
      const payload = {
        idClass: this.dataFilters.idClass,
        idGrade: this.dataFilters.idGrade,
        status: this.dataFilters.status,
        nameOrPhone: this.dataFilters.nameOrPhone,
        page: this.pagination.page,
        limit: this.pagination.limit,
      }
      this.$store.dispatch('parentStore/fetchFilterManagerParent', payload)
    },

    handleExportExcel() {
      this.$emit("exportExcel", "all");
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/.el-menu--horizontal {
    border-radius: 6px;

    .el-submenu .el-submenu__title {
      height: 36px;
      line-height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    i {
      color: #fff;
    }
  }
</style>